import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { 
  postDocumentManagement, 
  resetViewDocumentManagement, 
  deleteDocument, 
  resetDeleteDocumentManagement,
  putDocumentManagement,
  resetEditDocumentManagement,
  viewDocumentPost,
} from '../../../../redux/reducers/DocumentManagement';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import { ErrorSnackbar, SuccessSnackbar } from '../../../../components/CustomSnackBar';
import EditFile from './EditFile';
import CircularProgress from '@mui/material/CircularProgress';


import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  Button,
  Box,
  InputAdornment,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    position: 'relative',
    '&&': {
      fontFamily: '"articulat-cf", sans-serif !important',
    },
  },
  title: {
    fontFamily: 'articulat-cf", sans-serif !important',
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: 24.84,
    textAlign: 'left',
    color: '#3B4149',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  searchInput: {
    marginBottom: 16,
  },
  AddButton: {
    '&&': {
      marginLeft: '10px',
      paddingRight: '15px',
      color: '#FFF',
      background: '#0288D1',
      border: '1px solid #0288D1',
      textTransform: 'none',
      '&:hover': {
        color: '#0288D1',
        backgroundColor: '#FFF',
        borderRadius: '5px',
      },
    },
  },
  container: {
    maxHeight: '400px',
    overflow: 'auto',
  },
  cancelButton: {
    '&&': {
      color: '#01579B',
      border: '1px solid #01579B',
      marginRight: '10px',
      textTransform: 'none',
      '&:hover': {
        color: '#FFF',
        backgroundColor: '#01579B',
        borderRadius: '5px',
      },
    },
  },
  saveButton: {
    '&&': {
      color: '#FFF',
      background: '#0288D1',
      border: '1px solid #0288D1',
      textTransform: 'none',
      '&:hover': {
        color: '#0288D1',
        backgroundColor: '#FFF',
        borderRadius: '5px',
      },
    },
  },
}));

const SeeAllFiles = ({ accountId, handleCloseModal }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {errorMsg, successMsg, documentStatus, viewDocumentManagementData, fileAvailable } = useSelector(
    ({documentManagement}) => documentManagement,
  );
  const files = useSelector((state) => state.documentManagement.documentManagementData);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState('');

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogAction, setDialogAction] = useState('');
  const [dialogContent, setDialogContent] = useState('');
  const [documentToDelete, setDocumentToDelete] = useState(null);
  const [documentName, setDocumentName] = useState('');
  const [loadingDocId, setLoadingDocId] = useState(null);

  const handleOpenConfirmationDialog = (docId, documentName) => {
    setDocumentToDelete(docId);
    setDocumentName(documentName);
    setOpenDialog(true);
    setDialogAction("confirmation");
  };

  const handleOpenEditDialog = (docId, companyValue, fileTypeValue, descriptionValue) => {
    setOpenDialog(true);
    setDialogAction("editFile");
    setDialogContent(
      <EditFile 
        docId={docId} 
        companyValue={companyValue} 
        fileTypeValue={fileTypeValue} 
        descriptionValue={descriptionValue} 
        handleCloseDialog={handleCloseDialog} 
        editFileFunction={editFileFunction}
      />);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDialogContent(null);
    setDialogAction('');
  };

  const confirmDelete = () => {
    if (documentToDelete) {
      dispatch(deleteDocument(documentToDelete, accountId));
      setTimeout(() => {
        dispatch(resetDeleteDocumentManagement());
      }, 5000);
      setDocumentToDelete(null);
      handleCloseDialog();
    }
  };

  const editFileFunction = (docId, companyValue, fileTypeValue, descriptionValue) => {
    dispatch(putDocumentManagement({
      accountDocumentId: docId,
      documentType: companyValue,
      documentSubtype: fileTypeValue,
      documentDescription: descriptionValue,
    }, {accountId, isDirty: true}));
    setTimeout(() => {
      dispatch(resetEditDocumentManagement());
    }, 5000);
    handleCloseDialog();
  };

  useEffect(() => {
    getDocumentManagementData();
    return () => {
      dispatch(resetViewDocumentManagement()); 
    };
  }, [dispatch, accountId]);

  const getDocumentManagementData = () => {
    dispatch(
      postDocumentManagement
      (
        {
          accountNumber: accountId,
          documentDescription:"",
          documentSubtype:"",
          documentType:"",
          endDate:null,
          limit:999999999,
          orderBy:"",
          orderDirection:"",
          page:1,
          search:"",
          startDate: null
        }
      )
    );
  };

  const handleViewDocument = (documentLocation, docId) => {
    setLoadingDocId(docId);
    if (documentLocation) {
      // Determine base URL based on environment
      const baseURL = window.location.origin;
      // Build the document path
      const filePath = `${baseURL}${documentLocation.replace("data", "")}`;
      // Define root URL for the POST request
      const rootURL = process.env.REACT_APP_API_END_POINT;
  
      const body = {
        "root_url": rootURL,
        "Records": [
          {
            "path": filePath,
            "ref_label": "document"
          }
        ]
      };
      dispatch(viewDocumentPost(body));
    }
  };  

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const filteredDocs = files.filter
  ((file) => 
    (
      file.uploadedUser+' '+
      file.documentName+' '+
      file.documentType+' '+
      file.documentSubtype+' '+
      file.documentDescription
    ).toLowerCase().includes(searchText)
  );

  useEffect(() => {
    if (documentStatus==200) {
      getDocumentManagementData();
    }
  }, [documentStatus, dispatch]);

  useEffect(() => {
    if (fileAvailable === true && viewDocumentManagementData) {
      window.open(viewDocumentManagementData, '_blank');
      dispatch(resetViewDocumentManagement());
      setLoadingDocId(null);
    }
  }, [viewDocumentManagementData, fileAvailable, dispatch]); 

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="h6" component="h2">
        Document Management
      </Typography>
      <Box display="flex" justifyContent="flex-end">
        <TextField
          label="Search File"
          variant="outlined"
          className={classes.searchInput}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton onChange={handleSearchChange} edge="start">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button
          type="submit"
          color="inherit"
          size="medium"
          className={classes.AddButton}
          onClick={(e) => {
            e.stopPropagation();
            handleCloseModal('addFile');
          }}
        >
          <AddIcon /> Add
        </Button>
      </Box>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: '#4CAF50',
                color: '#FFFFFF',
              }}
            >
              <TableCell>Actions</TableCell>
              <TableCell>User</TableCell>
              <TableCell>Doc. Name</TableCell>
              <TableCell>Company</TableCell>
              <TableCell>File Type</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Date Uploaded</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredDocs
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.accountDocumentId}>
                  <TableCell sx={{ width: '35%' }} >
                    <div style={{ display: 'flex' }}>
                      <Button type="button" id={row.accountDocumentId+"_viewButton"} onClick={() => handleViewDocument(row.documentLocation, row.accountDocumentId)} >
                        {loadingDocId === row.accountDocumentId ? <CircularProgress size={24} /> : <VisibilityOutlinedIcon />}
                      </Button>
                      <Button type="button" id={row.accountDocumentId+"_editButton"} onClick={() => 
                        handleOpenEditDialog(
                          row.accountDocumentId, 
                          row.documentType, 
                          row.documentSubtype, 
                          row.documentDescription 
                        )} >
                        <EditOutlinedIcon />
                      </Button>
                      <Button type="button" id={row.accountDocumentId+"_deleteButton"} onClick={() => handleOpenConfirmationDialog(row.accountDocumentId, row.documentName)} >
                        <DeleteOutlineOutlinedIcon />
                      </Button>
                    </div>
                  </TableCell>
                  <TableCell sx={{ width: '5%' }}>{row.uploadedUser}</TableCell>
                  <TableCell sx={{ width: '35%' }}>{row.documentName}</TableCell>
                  <TableCell sx={{ width: '5%' }}>{row.documentType}</TableCell>
                  <TableCell sx={{ width: '5%' }}>{row.documentSubtype}</TableCell>
                  <TableCell sx={{ width: '10%' }}>{row.documentDescription}</TableCell>
                  <TableCell sx={{ width: '5%' }}>{moment(row.updatedDttm).utc().format('MM/DD/YYYY')}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={filteredDocs.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {dialogAction == 'confirmation' ? (
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Delete Document Record"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this <b>{ documentName }</b> document?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary" className={classes.cancelButton}>
              No
            </Button>
            <Button onClick={confirmDelete} color="primary" className={classes.saveButton} autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <Dialog
          open={openDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Edit Document Record"}</DialogTitle>
          <DialogContent>
            { dialogContent }
          </DialogContent>
        </Dialog>
      )}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
};

export default SeeAllFiles;
